import CopyAllIcon from '@mui/icons-material/CopyAll';
import {useContext, useState} from "react";
import AuthContext from "../../context/AuthContext";
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import {LightTooltip} from "../_subcomponents/MapToolsBase";
import DialogNoSibling from "../_subcomponents/DialogNoSibling";
import DialogInsertTemplate from "../_subcomponents/DialogInsertTemplate";

export default function FeatmapTools(props: any) {
    let {user, authTokens, serverIP, userPermissions} = useContext(AuthContext)

    let {keyDataSet, setCondObject, setReturnObj} = props

    const [siblingOpen, setSiblingOpen] = useState(false);

    function handleSiblingCopy() {
        fetch(`${serverIP}/featcopysibling/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify({...keyDataSet}),
        }).then(res => res.json())
            .then((data) => {
                if (data.status === 200) {
                    setReturnObj(data.siblingMapObj.returnObj)
                    setCondObject(data.siblingMapObj.condObj)
                } else {
                    // console.log('No siblings found')
                    setSiblingOpen(true)
                }
            })
    }

    const [templateOpen, setTemplateOpen] = useState(false);

    return (
        <>
            {/* Insert from template */}
            <DialogInsertTemplate
                open={templateOpen}
                setOpen={setTemplateOpen}
                setReturnObj={setReturnObj}
                setCondObject={setCondObject}
                projUID={keyDataSet.projUID}
            />
            <LightTooltip title="Insert from template or existing mapping">
                <FolderSpecialIcon
                    color="action"
                    className={userPermissions.canEdit ? "icon-clickable" : "icon-nonclickable"}
                    sx={{"& :hover": { color: "#2f478e"}}}
                    onClick={userPermissions.canEdit ? () => setTemplateOpen(true) : undefined}
                />
            </LightTooltip>

            {/* Use sibling mapping */}
            {!['0', 'usemap'].includes(keyDataSet.valUID) &&
                <>
                    <DialogNoSibling open={siblingOpen} setOpen={setSiblingOpen} />
                    <LightTooltip title="Use sibling mapping">
                        <CopyAllIcon
                            color="action"
                            className={userPermissions.canEdit ? "icon-clickable" : "icon-nonclickable"}
                            sx={{"& :hover": {color: "#2f478e"}}}
                            onClick={userPermissions.canEdit ? handleSiblingCopy : undefined}
                        />
                    </LightTooltip>
                </>}
        </>
    )
}
